import { FC } from 'react';
import CopyTextButton from 'v3/common/components/CopyTextButton';

const Fyers: FC = () => {
  return (
    <div id="stepper__container">
      <h3>Fyers API Setup</h3>

      <div className="stepper">
        <li className="stepper_item" data-stepper="1">
          <div className="stepper_content">
            <h2 className="stepper__heading">Click below to open FYERS API portal</h2>

            <a
              href="https://fyers.in/web/api-dashboard/user-apps"
              target="_blank"
              rel="noreferrer"
              className="stepper-btn"
            >
              Fyers
            </a>
          </div>
        </li>

        <li className="stepper_item" data-stepper="2">
          <div className="stepper_content">
            <h2 className="stepper__heading">Fill the app details as below</h2>

            <p>
              <strong>Step:</strong> Retrieve the <span className="highlight-text">primary IP address</span>{' '}
              from <span className="text-primary">Quantman support</span>, copy the{' '}
              <span className="highlight-text">redirect URL</span> using the &quot;
              <span className="highlight-text">Copy</span>&quot; button, paste it into the{' '}
              <span className="highlight-text">required field</span>, and fill in the remaining fields as
              shown in the image, keeping the <span className="highlight-text">format consistent</span>.
            </p>

            <div className="stepper__form">
              <div className="stepper__form-group">
                <h6>Primary IP Address</h6>
                <p>
                  For any queries related to <span className="text-primary">IP</span>, please contact Quantman
                  support
                </p>
              </div>

              <div className="stepper__form-group">
                <h6>Redirect URL</h6>
                <div className="stepper__input-group">
                  <input value="https://quantman.trade/auth/fyers/callback" disabled />
                  <CopyTextButton text="https://quantman.trade/auth/fyers/callback" />
                </div>
              </div>
            </div>

            <img src="/landing-page-img/brokers-img/fyers-1.png" alt="Fill Form" />
          </div>
        </li>

        <li className="stepper_item" data-stepper="4">
          <div className="stepper_content">
            <h2 className="stepper__heading">
              Click the checkbox <span>I accept the API Terms and Conditions</span>
            </h2>
          </div>
        </li>

        <li className="stepper_item" data-stepper="5">
          <div className="stepper_content">
            <h2 className="stepper__heading">
              Finally Click the <span>Activate</span> button
            </h2>
          </div>
        </li>

        <li className="stepper_item" data-stepper="6">
          <div className="stepper_content">
            <h2 className="stepper__heading">Copy your API Credentials</h2>

            <img src="/landing-page-img/brokers-img/fyers-2.png" alt="Credentials" />
          </div>
        </li>
      </div>
    </div>
  );
};

export default Fyers;
